export default {
  setTemplateConfig: (state, templateConfig) => {
    state.templateConfig = {
      ...state.templateConfig,
      ...templateConfig,
    };
  },
  setMerchantConfig: (state, merchantConfig) => {
    state.merchantConfig = {
      ...state.merchantConfig,
      ...merchantConfig,
    };
  },
  setOTPDetails: (state, OTPDetails) => {
    state.OTPDetails = { ...state.OTPDetails, ...OTPDetails };
  },

  setUnsubscribeFlowDetails: (state, UnsubscribeFlowDetails) => {
    state.UnsubscribeFlowDetails = {
      ...state.UnsubscribeFlowDetails,
      ...UnsubscribeFlowDetails,
    };
  },
  setSubscribeFlowDetails: (state, SubscribeFlowDetails) => {
    state.SubscribeFlowDetails = {
      ...state.SubscribeFlowDetails,
      ...SubscribeFlowDetails,
    };
  },
};
